import { useContext } from "react";
import { useAtomValue } from "jotai";

import { AuthContext } from "contexts/auth";
import { loadingAtom } from "states/loadingAtom";
import ButtonV2 from "components/shared/buttonV2";

import styles from "./index.module.scss";

/* バージョンが古い時のリロード強制アラート */
const ReloadAlert: React.FC = () => {
  const { token, needReload, showLoadingGlobal } = useContext(AuthContext);
  const showLoading = useAtomValue(loadingAtom);

  return (
    <>
      {needReload && !showLoading && !showLoadingGlobal && token && (
        <div className={styles.overlay} onClick={(e) => e.stopPropagation()}>
          <div
            className={styles.container}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.title__red}>最新バージョンに更新</div>
            <div className={styles.modal_text}>
              一部機能が新しくなりました。
              <br />
              最新バージョンに更新してください。
            </div>
            <div
              className={`${styles.button_container} mx-16`}
              onClick={() => {
                window.location.reload();
              }}
            >
              <ButtonV2 variant="primary" layout="fullWidth" btnType="submit">
                更新する
              </ButtonV2>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReloadAlert;
